// extracted by mini-css-extract-plugin
export default {"popup":"CheckPreparationBatch__popup--rrGtEmP6VspvE5zwj4sg"};